import { useGetParams } from '../../hooks/useGetParams';
import styles from './Variant.module.css';
import { motion } from 'framer-motion';

export const Variant = ({ item, index, isQuestionImg, aciveAmimate }) => {
  const { answerFontSize, varNumFontSize } = useGetParams();

  const clrBgVar = isQuestionImg ? '#021323' : '#08355a';

  // анимация правильного варианта
  const variants = {
    inactive: {
      backgroundImage: `linear-gradient(0deg, ${clrBgVar}, ${clrBgVar})`,
      boxShadow: '0 0 2rem rgba(105, 188, 55, 0)',
    },
    active: {
      backgroundImage: 'linear-gradient(0deg, #3eb41b, #244304)',
      boxShadow: '0 0 2rem rgba(105, 188, 55, 1)',
    },
  };

  const borderVar = {
    inactive: {
      backgroundImage: 'linear-gradient(-90deg, #0230a0, #3ab5f9)',
    },
    active: {
      backgroundImage: 'linear-gradient(-90deg, #E9FF90, #A4FF2D )',
    },
  };

  const numberVariants = {
    inactive: {
      border: '0.1rem solid #fff',
      backgroundImage: 'linear-gradient(90deg, #39b3f8, #0942d2)',
    },
    active: {
      border: '0.1rem solid #BDC900',
      backgroundImage: 'linear-gradient(90deg, #00970B, #3B6406)',
    },
  };

  const titleVariants = {};

  return (
    <motion.div
      variants={variants}
      initial="inactive"
      animate={aciveAmimate ? 'active' : 'inactive'}
      transition={{ duration: 0.5, delay: 1 }}
      className={styles.variant}
      style={{ minHeight: isQuestionImg ? '10rem' : '12rem' }}
    >
      <motion.div
        variants={borderVar}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 0.5, delay: 1 }}
        className={styles.borderVar}
      />

      <motion.div
        variants={numberVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 0.5, delay: 1 }}
        className={styles.varNumber}
        style={{
          fontSize: `${varNumFontSize}rem`,
          height: `${1.8 * varNumFontSize}rem`,
          minWidth: `${1.8 * varNumFontSize}rem`,
        }}
      >
        {index + 1}
      </motion.div>
      <motion.div
        variants={titleVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 0.5, delay: 1 }}
        className={styles.varTitle}
        style={{
          fontSize: `${answerFontSize}rem`,
          lineHeight: `${answerFontSize}rem`,
          maxWidth: isQuestionImg ? '78rem' : '100%',
        }}
      >
        {item.comment}
      </motion.div>
    </motion.div>
  );
};
